import demoGameListDesktop from "../../public/images/demos/derbywars-demo-game-list.gif";
import demoGameListMobile from "../../public/images/demos/derbywars-demo-game-list-mobile.gif";
import demoGameBoardDesktop from "../../public/images/demos/derbywars-demo-game-board.gif";
import demoGameBoardMobile from "../../public/images/demos/derbywars-demo-game-board-mobile.gif";
import demoLeaderboardDesktop from "../../public/images/demos/derbywars-demo-leaderboard.gif";
import demoLeaderboardMobile from "../../public/images/demos/derbywars-demo-leaderboard-mobile.gif";
import { Link } from "react-router-dom";
import React from "react";

export default function HowToSteps() {
  return (
    <div>
      <div className="l-row l-row--white l-row--bottom-border">
        <div className="l-wrapper">
          <div className="l-content text-center">
            <h2>
              1) How To Find A Game
            </h2>

            <p>
              Browse game types on the
              {" "}

              <Link to="/">
                Tournaments List
              </Link>

              {" "}
              to find the right game for you.
            </p>

            <p>
              Click the &quot;Enter&quot; button to view the details of a game.
            </p>

            <p>
              Then click the &quot;Enter Now&quot; button to purchase a
              {" "}

              <i className="dw-ticket-solid dw--1-5x color--is-copen-blue" />

              {" "}
              Ticket!
            </p>

            <div className="device device--mobile hidden--desktop">
              <ul className="device_controls device_controls--speaker">
                <li />
              </ul>

              <img src={demoGameListMobile} />

              <ul className="device_controls device_controls--home">
                <li />
              </ul>
            </div>

            <div className="device device--desktop visible--desktop">
              <ul className="device_controls">
                <li />

                <li />

                <li />
              </ul>

              <img src={demoGameListDesktop} />
            </div>
          </div>
        </div>
      </div>

      <div className="l-row l-row--lighter-gray">
        <div className="l-wrapper">
          <div className="l-content text-center">
            <h2>
              2) How To Pick Your Horses
            </h2>

            <p>
              Pick a
              {" "}

              <button className="btn btn--small btn--mock" type="button">
                P
              </button>

              {" "}

              <strong>
                Primary Horse
              </strong>

              {" "}
              and an (optional)

              {" "}

              <button className="btn btn--small btn--mock" type="button">
                A
              </button>

              {" "}

              <strong>
                Alternate Horse
              </strong>

              {" "}
              in each race in the game below your

              {" "}

              <i className="dw-ticket-solid dw--1-5x color--is-copen-blue" />

              {" "}
              Ticket.
            </p>

            <p>
              If your
              {" "}

              <strong>
                Primary Horse
              </strong>

              {" "}
              is scratched, then your

              {" "}

              <strong>
                Alternate Horse
              </strong>

              {" "}
              will become your pick for that race.
            </p>

            <div className="device device--mobile hidden--desktop">
              <ul className="device_controls device_controls--speaker">
                <li />
              </ul>

              <img src={demoGameBoardMobile} />

              <ul className="device_controls device_controls--home">
                <li />
              </ul>
            </div>

            <div className="device device--desktop visible--desktop">
              <ul className="device_controls">
                <li />

                <li />

                <li />
              </ul>

              <img src={demoGameBoardDesktop} />
            </div>
          </div>
        </div>
      </div>

      <div className="l-row l-row--white l-row--bottom-border">
        <div className="l-wrapper">
          <div className="l-content text-center">
            <h2>
              3) How To Score Points and Win!
            </h2>

            <p>
              If your horse finishes in 1st, 2nd or 3rd place then your Score for that race is added to your
              {" "}

              <i className="dw-ticket-solid dw--1-5x color--is-copen-blue" />

              {" "}
              Ticket&apos;s total Score in the

              {" "}

              <strong>
                Leaderboard
              </strong>

              {"." /* eslint-disable-line react/jsx-curly-brace-presence */ }
            </p>

            <p>
              If your
              {" "}

              <i className="dw-ticket-solid dw--1-5x color--is-copen-blue" />

              {" "}
              Ticket has the highest Score at the end of the last race in the game, you win!
            </p>

            <div className="device device--mobile hidden--desktop">
              <ul className="device_controls device_controls--speaker">
                <li />
              </ul>

              <img src={demoLeaderboardMobile} />

              <ul className="device_controls device_controls--home">
                <li />
              </ul>
            </div>

            <div className="device device--desktop visible--desktop">
              <ul className="device_controls">
                <li />

                <li />

                <li />
              </ul>

              <img src={demoLeaderboardDesktop} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
